/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sms": {
        "nested": {
          "ManagePhoneNumberRequest": {
            "nested": {
              "PhoneNumberAction": {
                "values": {
                  "DO_NOT_USE": 0,
                  "BLOCK": 1,
                  "UNBLOCK": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sms?.nested?.ManagePhoneNumberRequest?.nested?.PhoneNumberAction) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ManagePhoneNumberRequest @ squareup/sms/sms.proto at 368:1
 */
export const ManagePhoneNumberRequest = {};
/**
 * SOURCE PhoneNumberAction @ squareup/sms/sms.proto at 381:3
 */
ManagePhoneNumberRequest.PhoneNumberAction = $root.lookupEnum('squareup.sms.ManagePhoneNumberRequest.PhoneNumberAction').values;